<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="调拨单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>调拨单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="outWarehouseId" label="调出库房" v-if="getIsView()">
                <el-select v-model="form.outWarehouseName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getWarehousesBySessionWarehouseId" @change="outWarehouseChange" style="width:100%">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>调出库房:{{ form.outWarehouseName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="outWarehouseManagerName" label="调出库房管理员" v-if="getIsView()">
                <el-input disabled v-model="form.outWarehouseManagerName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>调出库房管理员:{{ form.outWarehouseManagerName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="inWarehouseId" label="调入库房" v-if="getIsView()">
                <el-select v-model="form.inWarehouseName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getInWarehouseList" @change="inWarehouseChange" style="width:100%">
                  <el-option v-for="item in inWarehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>调入库房:{{ form.inWarehouseName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="inWarehouseManagerName" label="调入库房管理员" v-if="getIsView()">
                <el-input disabled v-model="form.inWarehouseManagerName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>调入库房管理员:{{ form.inWarehouseManagerName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总数量:{{ form.totalNumber }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                <el-input disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">调拨明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" type="danger" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
            <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
            <el-input :disabled="!editMode" placeholder="扫描标签码添加明细" v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column show-overflow-tooltip prop="productName" label="产品" width="180" fixed> </el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" label="产品规格" width="130" fixed></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>

            <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证" width="180"></el-table-column>
            <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="130"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="130"></el-table-column>
            <el-table-column prop="number" label="数量" width="120"> </el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
            <el-table-column prop="packSpec" label="包装规格" width="120"></el-table-column>
            <el-table-column prop="price" label="单价" width="120"></el-table-column>
            <el-table-column prop="amount" label="小计" width="120"></el-table-column>
            <el-table-column prop="outLocationName" label="调出货位" width="180"></el-table-column>
            <el-table-column prop="inLocationName" label="调入货位" width="180"></el-table-column>
            <el-table-column prop="batch" label="批次号" width="120"> </el-table-column>
            <el-table-column prop="validityDate" label="有效期" width="150">
              <template slot-scope="scope">
                {{ scope.row.validityDate? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
            <el-table-column prop="longTime" label="长期" width="60">
              <template slot-scope="scope">
                {{ scope.row.longTime == 1 ? "是" : "否"}}
              </template>
            </el-table-column>
            <el-table-column prop="manufactureDate" label="生产日期" width="150">
              <template slot-scope="scope">
                {{scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
            <el-table-column prop="serialNo" label="序列号" width="120"></el-table-column>
            <el-table-column prop="unit" label="包装单位" width="80"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
            <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row v-if="isScan">
            <el-col :span="24">
              <el-form-item label="扫码框">
                <el-input placeholder="请扫码" ref="no" @change="mainNoChange" v-model="childForm.no" @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="mainNo" label="主条码">
                <el-input disabled placeholder="请输入主条码" v-model="childForm.mainNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="traceNo" label="追溯码">
                <el-input disabled placeholder="请输入追溯码" v-model="childForm.traceNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-input disabled v-model="childForm.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productName" label="产品名称">
                <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>

                <SelectTable v-if="!isScan" :disabled="!editMode" :columns="stockColumns" :innerName="childForm.productName" :dataList="STATIC_Stocks" @filterMethod="getProductList" @change="productChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertId" label="产品注册证">
                <el-input disabled v-model="childForm.productRegistCertName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="supplierName" label="供应商">
                <el-input disabled v-model="childForm.supplierName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="onlineNo" label="挂网号">
                <el-input disabled v-model="childForm.onlineNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="childForm.brand"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="locationName" label="调出货位">
                <el-select :disabled="!editMode" placeholder="请选择调出货位" v-model="childForm.outLocationId" style="width:100%">
                  <el-option v-for="item in outLocationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="locationName" label="调入货位">
                <el-select :disabled="!editMode" placeholder="请选择调入货位" v-model="childForm.inLocationId" style="width:100%">
                  <el-option v-for="item in inLocationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="childForm.minUnit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="unit" label="包装单位">
                <el-input disabled v-model="childForm.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufactureDate" label="生产日期">
                <el-date-picker disabled v-model="childForm.manufactureDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择生产日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="validityDate" label="有效期">
                <el-date-picker disabled v-model="childForm.validityDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择有效期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item prop="longTime" label="长期">
                <el-switch v-model="childForm.longTime" disabled active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="batch" label="批次号">
                <el-input disabled placeholder="请输入批次号" v-model="childForm.batch"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="serialNo" label="序列号">
                <el-input disabled placeholder="请输入序列号" v-model="childForm.serialNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input disabled v-model="childForm.packSpec"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="price" label="单价">
                <el-input disabled @input="autoAmount" v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="amount" label="金额">
                <el-input disabled v-model="childForm.amount"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import OutStockScan from '@/mixin/outStockScan-mixin'
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetStockTransferById,
  RejectStockTransfer,
  SaveStockTransfer,
  GetAcceptInStockById,
  GetWarehouseById,
  GetWarehouses
} from "@/api";
import { StockCategoryOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, OutStockScan,tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    LabelDetailsDialog,
    PackageLabelDialog
  },
  data () {
    return {
      GetDataAction: GetStockTransferById,
      SaveDataAction: SaveStockTransfer,
      reject: RejectStockTransfer,
      form: {},
      StockCategoryOptions: StockCategoryOptions,
      rules: {
        outWarehouseId: [
          { required: true, message: '请选择调出库房', trigger: 'blur' }
        ],
        inWarehouseId: [
          { required: true, message: '请选择调入库房', trigger: 'blur' }
        ],
      },
      childFormRules: {
        productName: [{ required: true, message: "请选择产品", trigger: "blur" }],
        price: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      isScan: false,
      outLocationList: [],
      inWarehouseList: [],
      inLocationList: [],
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
      if (query.acceptInStockId) {
        this.acceptInStockChange(query.acceptInStockId)
      }
    }

    this.getWarehousesBySessionWarehouseId('')
    // this.getSuppliers('');
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;

      if (this.form.outWarehouseId) {
        this.outWarehouseChange(this.form.outWarehouseId)
      }

    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        // this.getLocations(this.form.outWarehouseId);
        // this.getLocations(this.form.inWarehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        this.outWarehouseChange(this.form.outWarehouseId)
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        this.$store.dispatch('SetLoading',true)
        if (!valid) {
          this.$store.dispatch('SetLoading',false)   
          return false;
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        warehouseCategory: "1",
        "outWarehouseId": this.userInfo.defaultWarehouseId,
        outWarehouseName: this.userInfo.defaultWarehouseName,
        outWarehouseManagerId: this.userInfo.defaultWarehouseManagerId,
        outWarehouseManagerName: this.userInfo.defaultWarehouseManagerName,
        totalNumber: 0,
        totalAmount: 0,
        category: 0,
        remark: "",
        details: [],
        userName: '',
        userId: '',
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
      if (!this.userInfo.isAdmin) {
        let warehouseId = sessionStorage.getItem('warehouseId')
        let outWarehouse = this.userInfo.warehouseInfos.find(e => e.id == warehouseId)
        if (outWarehouse) {
          this.form.outWarehouseId = outWarehouse.id
          this.form.outWarehouseName = outWarehouse.name
          this.form.outWarehouseManagerId = outWarehouse.managerId
          this.form.outWarehouseManagerName = outWarehouse.managerName
        }
      }

    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm () {
      if(this.checkIsRfid(this.childMultipleSelection)){
        this.$my_message(`存在打包类标签明细，不能删除！`, "warning");
        return
      }
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      // this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        "locationName": "",
        "mainNo": "",
        "traceNo": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        productRegistCertId: '',
        "productRegistCertNo": "",
        "onlineNo": "",
        "unit": "",
        "minUnit": "",
        "packSpec": "",
        "manufacturerId": '',
        "locationId": '',
        "manufactureDate": "",
        "batch": "",
        "validityDate": "",
        "serialNo": "",
        "number": 1,
        unChargeNumber: 1,
        "price": 0,
        "amount": 0,
        "remark": ""
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList('')
    },
    pushChildForm (close) {
      let result = true
      this.$refs["childForm"].validate((valid) => {
        result = valid
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        if (this.childForm.mainNo && this.childForm.traceNo) {
          var childForm = this.childForm
          // 添加行
          let arr = this.form.details.filter(
            (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
          );

          // 添加行记录
          if (arr.length > 0) {
            // 存在则把列表的数据拿过来，并且数量加1
            this.form.details = this.form.details.map((item) => {
              if (
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo
              ) {
                item.packSpec = childForm.packSpec;
                item.locationId = childForm.locationId;
                item.locationName = childForm.locationName;
                item.manufactureDate = childForm.manufactureDate;
                item.batch = childForm.batch;
                item.validityDate = childForm.validityDate;
                item.serialNo = childForm.serialNo;
                item.remark = childForm.remark;
                item.number = childForm.number;
                // item.unUseNumber = childForm.unUseNumber
                item.price = childForm.price;
                item.amount = childForm.amount;
              }
              return item;
            });
          } else {
            // 不存在则添加行记录
            var childForm = JSON.parse(JSON.stringify(this.childForm))
            childForm.$index = this.form.details.length + 1
            this.form.details.push(childForm)
          }
        }
        else {
          if (this.editChildren) {
            let item = this.form.details.find(
              (e) => e.$index == this.childForm.$index
            );
            Object.assign(item, this.childForm);
          }
          else {
            this.form.details.push(this.childForm)
          }
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
          this.isScan = false;
        }
      });
      return result
    },
    childNumberChange () {
      this.childForm.unChargeNumber = this.childForm.number
      this.autoAmount();
    },
    autoAmount () {
      // this.childForm.billingPrice = this.childForm.price
      this.childForm.amount = (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // scan

    openScanner (ev) {
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;

      ev.target.blur();
    },

    // change event
    acceptInStockChange (id) {
      GetAcceptInStockById({ id: id })
        .then(res => {
          this.outWarehouseChange(res.returnData.warehouseId)
          this.form.remark = res.returnData.remark
          this.form.details = res.returnData.details
          this.form.details.map((item, index) => {
            item.supplierId = res.returnData.supplierId
            item.supplierName = res.returnData.supplierName
            item.outLocationId = item.locationId
            item.outLocationName = item.locationName
            item.$index = index + 1

            return item
          })

          this.autoTotalAmount()
        })
    },
    outWarehouseChange (val) {
      this.form.outWarehouseId = val
      GetWarehouseById({ id: val })
        .then(res => {
          this.form.outWarehouseName = res.returnData.name
          this.form.outWarehouseManagerId = res.returnData.managerId
          this.form.outWarehouseManagerName = res.returnData.managerName
          this.outLocationList = res.returnData.details

          this.form.outWarehouseCategory = res.returnData.category

          this.getProductList('')

          let deptIds = res.returnData.deptIds.split(';')
          this.form.outWarehouseDeptId = deptIds[0]

          this.getInWarehouseList('')
        })
    },
    inWarehouseChange (val) {
      this.form.inWarehouseId = val
      GetWarehouseById({ id: val })
        .then(res => {
          this.form.inWarehouseName = res.returnData.name
          this.form.inWarehouseManagerId = res.returnData.managerId
          this.form.inWarehouseManagerName = res.returnData.managerName
          this.inLocationList = res.returnData.details
          let deptIds = res.returnData.deptIds.split(';')
          this.form.inWarehouseDeptId = deptIds[0]
        })
    },
    productChange (row) {
      let id = this.childForm.id
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      this.childForm = Object.assign(this.childForm, row)// this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      this.childForm.id = id
      // this.childForm.supplierProductId = row.id
      this.childForm.number = 1
      this.childForm.remark = ''

      this.childForm.outLocationId = row.locationId
      this.childForm.outLocationName = row.locationName
      this.childForm.amount = this.childForm.price

      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.childForm.validateField('productName')
    },




    getProductList (keyWord) {
      let query = {
        // userId: this.storage.getItem('user').id,
        pageIndex: 1,
        pageSize: 50,
        keyWord: keyWord,
        category: 0,
        warehouseId: this.form.outWarehouseId
      }
      // query.pageIndex = 1
      // query.pageSize = 50
      // query.category = 0
      // query.warehouseId = this.form.outWarehouseId
      this.getStocks(query)
    },
    getInWarehouseList (val) {
      // if (!this.form.outWarehouseId) {
      //   this.inWarehouseList = []
      //   this.inLocationList = []
      // }

      // let outWarehouse = this.STATIC_Warehouses.find(e => e.id == this.form.outWarehouseId)

      let query = {
        pageIndex: 1,
        pageSize: 50,
        keyWord: val,
        // category: this.form.outWarehouseCategory,
        state: 1
      }
      GetWarehouses(query)
        .then(res => {
          this.inWarehouseList = res.returnData.data
        })
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
